export enum SUBMISSIONS_STATUSES {
  NEW = 'NEW',
  SCREENING = 'SCREENING',
  SHORTLISTED = 'SHORTLISTED',
  PENDING_CONFIRMATION_TECHNICAL = 'PENDING_CONFIRMATION_TECHNICAL',
  REQUEST_TO_RESCHEDULE = 'REQUEST_TO_RESCHEDULE',
  READY_FOR_TECHNICAL = 'READY_FOR_TECHNICAL',
  INTERVIEW_ON_PROGRESS_TECHNICAL = 'INTERVIEW_ON_PROGRESS_TECHNICAL',
  TECHNICAL_PASSED = 'TECHNICAL_PASSED',
  TECHNICAL_FAILED = 'TECHNICAL_FAILED',
  PENDING_CONFIRMATION_HR = 'PENDING_CONFIRMATION_HR',
  REQUEST_TO_RESCHEDULE_HR = 'REQUEST_TO_RESCHEDULE_HR',
  READY_FOR_HR = 'READY_FOR_HR',
  INTERVIEW_ON_PROGRESS_HR = 'INTERVIEW_ON_PROGRESS_HR',
  HR_PASSED = 'HR_PASSED',
  HR_FAILED = 'HR_FAILED',

  DELETED = 'DELETED',
  INTERVIEWING = 'INTERVIEWING',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  REJECTED_HR = 'REJECTED_HR',
  CANCELED = 'CANCELED',
  CANCELED_HR = 'CANCELED_HR',
  OFFER_SENT = 'OFFER_SENT',
  REJECTED_WITHOUT_SCREENING = 'REJECTED_WITHOUT_SCREENING',
  PENDING_SHORTLISTING = 'PENDING_SHORTLISTING',
  PENDING_TECHNICAL_FEEDBACK = 'PENDING_TECHNICAL_FEEDBACK',
  PENDING_HR_FEEDBACK = 'PENDING_HR_FEEDBACK',
}

export enum MARK_AS_OPTIONS {
  ACCEPTED = 'ACCEPTED',
  CANCELED = 'CANCELED',
  REJECTED = 'REJECTED',
}

export enum RATING_VALUES {
  EXCELLENT = 'Excellent',
  GOOD = 'Good',
  AVERAGE = 'Average',
  BELOW_AVERAGE = 'Below Average',
  POOR = 'Poor',
  NOT_APPLICABLE = 'Not Applicable',
}

export enum DECISIONS {
  SELECTED = 'Selected',
  NOT_SELECTED = 'Not Selected',
}

export const SendOptions = {
  EMAIL: 'Email',
  TEXT: 'Text Message',
};

export const SUBMISSIONS_REFERENCE_SECTION = {
  SUBMISSIONS: 'Submissions',
};

export const SUBMISSIONS_CATEGORIES = {
  MESSAGES: 'Messages',
  RESCHEDULE_REASONS: 'Reschedule Reasons',
};

export const SUBMISSION_CATEGORIES_KEYS = {
  NAME: 'Name',
  MESSAGE: 'Message',
};

export enum SUBMISSION_REFERENCE_SECTION {
  SUBMISSION = 'Submissions',
  GENERAL = 'GENERAL',
}

export enum SUBMISSION_REFERENCE_CATEGORIES {
  LOCATIONS = 'Sub-locations',
  UNIVERSITIES = 'Sub-universities',
  TECHNICAL_QUESTIONS = 'Technical interview questions',
  HR_QUESTIONS = 'HR interview questions',
  EMPLOYMENT_TYPES = 'Employment types',
  WORKING_MODES = 'Working modes',
  POSITIONS = 'POSITIONS',
}

export enum SUBMISSION_REFERENCE_CATEGORY_FIELD {
  NAME = 'Name',
  QUESTIONS = 'Questions',
  TYPES = 'Type',
  MODE = 'Mode',
  POSITION = 'POSITION',
}
